import { render } from "./InstagramPhotos.vue?vue&type=template&id=06a7b4b0"
import script from "./InstagramPhotos.vue?vue&type=script&lang=js"
export * from "./InstagramPhotos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__